'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.formatPerformanceEntry = exports.getPerformanceEntriesByName = exports.clearPerformanceMeasure = exports.isPerformanceMeasure = exports.isPerformanceMark = undefined;

var _formatTiming = require('./formatTiming');

var _window = window,
    performance = _window.performance;

var ENTRY_TYPES = {
    MARK: 'mark',
    MEASURE: 'measure'
};

var isPerformanceMark = exports.isPerformanceMark = function isPerformanceMark(entry) {
    return entry.entryType === ENTRY_TYPES.MARK;
};

var isPerformanceMeasure = exports.isPerformanceMeasure = function isPerformanceMeasure(entry) {
    return entry.entryType === ENTRY_TYPES.MEASURE;
};

/**
 *
 * @param {PerformanceMeasure} measure
 */
var clearPerformanceMeasure = exports.clearPerformanceMeasure = function clearPerformanceMeasure(measure) {
    performance.clearMeasures(measure.name);
};

/**
 * Get performance entries by name from Performance API
 * @param {string} name
 * @returns {PerformanceEntry[]}
 */
var getPerformanceEntriesByName = exports.getPerformanceEntriesByName = function getPerformanceEntriesByName(name) {
    return performance.getEntriesByName(name);
};

/**
 * Formats Performance Entry objects for beacon request
 * @param {PerformanceEntry} entry
 * @returns {string}
 */
var formatPerformanceEntry = exports.formatPerformanceEntry = function formatPerformanceEntry(entry) {
    var name = entry.name,
        startTime = entry.startTime,
        duration = entry.duration;

    var time = 0;

    if (isPerformanceMark(entry)) {
        time = startTime;
    } else if (isPerformanceMeasure(entry)) {
        time = duration;
    }

    return (0, _formatTiming.formatTiming)(name, time);
};


//////////////////
// WEBPACK FOOTER
// ./~/@zillow/client-profiler-core/dist/utils/performanceEntryUtils.js
// module id = 418
// module chunks = 5